import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ContainerWiseAbstractModel } from './container-wise-abstract.model';

export class ContainerWiseAbstractResponseModel extends GlobalResponseObject {
    data: ContainerWiseAbstractModel;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, errorCode:number, internalMessage:string, data: ContainerWiseAbstractModel){
        super(status,errorCode,internalMessage);
        this.data = data;
    }
}